<communication-block
  [selectIdFromRoute]="saleSelectors.selectIdRouteParam"
  [selectEntityById]="saleSelectors.selectById"
  [availableTemplateTypes]="[
    templateTypes.BOOKING_UPCOMING_REMINDER,
    templateTypes.BOOKING_MODIFIED,
    templateTypes.PURCHASE_CONFIRMATION
  ]"
  [mergeFieldFilters]="['sale', 'member']"
  [customParticipationLoader]="loadSaleParticipations"
  [customSelectableMembersLoader]="loadSaleSelectableMembers"
  [saleId]="saleId$ | async"
></communication-block>
